import Vue from 'vue'

Vue.filter('empty', (value, empty) => {
  if (value === undefined || value === null || value === '') {
    return empty ? empty : '--';
  }

  return value;
})

Vue.filter('imgEmpty', (value, empty) => {
  if (value === undefined || value === null || value === '') {
    return empty ? empty : 'https://presale.jhtsoft.com/picms/c47499b67d489.png';
  }

  return value;
})



// WEBPACK FOOTER //
// ./src/util/emptyFilter.js